import { GameState, GlobalModifierInfo } from '../api';

const setupOnlyIds = new Set(['GameDifficulty', 'YeLiveliestAwfulness']);
const ongoingDescriptions: Record<string, string> = {
  DiscomfortingAdditionalClue: 'Each Mythos Clue appearance places 1 additional Clue at the same location.',
  UltimateCosmicEvilAdditionalMythos: 'Starting in round 2, resolve one additional Mythos card each Mythos phase.',
};

const isDifficultyModifier = (modifier: GlobalModifierInfo) =>
  modifier.sourceType === 'Difficulty'
  || (!modifier.sourceType && (setupOnlyIds.has(modifier.id) || Object.prototype.hasOwnProperty.call(ongoingDescriptions, modifier.id)));

/** Full difficulty metadata stays available even when its setup rules are omitted from Rules in play. */
export const getDifficultyPresentation = (state: GameState): { name: string; description: string } | undefined => {
  const modifier = state.globalModifiers?.find(isDifficultyModifier);
  if (!modifier) return undefined;
  const name = (typeof modifier.sourceCard?.name === 'string' ? modifier.sourceCard.name.trim() : '')
    || modifier.additionalData?.trim() || modifier.source?.trim();
  return name ? { name, description: modifier.textDescription?.trim() || '' } : undefined;
};

/** Return a presentation copy; the server's full description and gameplay modifier remain untouched. */
export const getOngoingDifficultyModifier = (modifier: GlobalModifierInfo): GlobalModifierInfo | undefined => {
  if (!isDifficultyModifier(modifier)) return modifier;
  if (setupOnlyIds.has(modifier.id)) return undefined;
  return {
    ...modifier,
    sourceType: 'Difficulty',
    textDescription: ongoingDescriptions[modifier.id] || modifier.textDescription,
  };
};
